<script lang="ts">
	import type { HelpPalletsProps } from "./HelpPalletsProps.js";
	import HelpPage from "../components/HelpPage.svelte";
	import { nbspify } from "../../../core/utils/nbspify.js";
	import { setContext } from "svelte";
	import smallGoods from "../assets/images/small-goods.png";
	import { thumbnailImageContextKey } from "../contexts/thumbnailImageContextKey.js";

	type $$Props = HelpPalletsProps;

	const { references, products, categories, blogPosts } = $$restProps as $$Props;

	setContext(thumbnailImageContextKey, smallGoods);
</script>

<HelpPage
	heading="Chci skladovat malé zboží"
	perex="Naše policové regály zahrnují klasické, s vysokou nosností, víceúrovňové a velkoplošné varianty, které lze přizpůsobit vašim potřebám. Spádové regály navíc umožňují princip FIFO (First In, First Out), což zjednodušuje manipulaci a zvyšuje efektivitu ve vašem skladu."
	{references}
	{products}
	{categories}
	{blogPosts}
>
	<p slot="subHeading">
		{nbspify("Pro skladování malého zboží nabízíme efektivní řešení, jako jsou")}
		<span class="text-primary">{nbspify("policové regály")}</span>
		a
		<span class="text-primary">{nbspify("spádové regály na drobné zboží,")}</span>
		{nbspify("které zajišťují přehlednost a rychlý přístup k jednotlivým položkám.")}
	</p>
</HelpPage>
